export default __webpack_public_path__ + "static/media/purple-gradient-circle.b8a4a0fc.svg";